import { observable } from 'mobx';
import { fetchAksSettings } from '@/services/common';

// aks配置信息
const common = observable({
  isLogin: false, // 是否登录
  // 获取aks加密准备信息
  async getAksInfo() {
    const res = await fetchAksSettings();
    if (!res || res.isLogin === false) {
      // 绕过登录的情况 标识未登录状态
      this.isLogin = false;
    } else {
      this.isLogin = true;
      if (window.cryptico) window.cryptico.setPublicKeyString(res);
    }
  },
});

export default common;
